module.exports = __webpack_public_path__ + "static/img/icon_sel.293cd239.png";